import React, { useEffect, useId, useRef } from "react";
import KpiDetail from "../../pages/kpis/KpiDetail";
import Button from "../../ui/Button";
import DrawerA11yWrapper from "../../ui/DrawerA11yWrapper";
import useContentFontScale from "../../hooks/useContentFontScale";

const ensureKpiDrawerAnimations = (() => {
  let injected = false;
  return () => {
    if (injected) return;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-kpi-drawer", "true");
    styleTag.innerHTML = `
@keyframes kpiDrawerSlide {
  from { transform: translateX(40px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@keyframes kpiDrawerFade {
  from { opacity: 0; }
  to { opacity: 1; }
}
`;
    document.head.appendChild(styleTag);
    injected = true;
  };
})();

export default function KpiDetailDrawer({ kpiId, onClose, onUpdated }) {
  const { scale: contentFontScale } = useContentFontScale();
  const titleId = useId();
  const closeRef = useRef(null);

  useEffect(() => {
    ensureKpiDrawerAnimations();
  }, []);

  if (!kpiId) return null;

  return (
    <DrawerA11yWrapper
      open={Boolean(kpiId)}
      onClose={onClose}
      labelledBy={titleId}
      initialFocusRef={closeRef}
      backdropStyle={overlayStyle}
      containerStyle={drawerStyle}
    >
      <div
        style={{
          fontSize: "calc(1rem * var(--content-font-scale))",
          "--content-font-scale": String(contentFontScale),
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={headerStyle}>
          <div id={titleId} style={{ fontSize: "18px", fontWeight: 600 }}>KPI Details</div>
          <Button
            onClick={onClose}
            variant="ghost"
            style={closeButtonStyle}
            aria-label="Close KPI drawer"
            ref={closeRef}
          >
            X
          </Button>
        </div>
        <div style={contentStyle}>
          <KpiDetail kpiId={kpiId} onClose={onClose} onUpdated={onUpdated} />
        </div>
      </div>
    </DrawerA11yWrapper>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "stretch",
  zIndex: 3000,
  animation: "kpiDrawerFade 0.2s ease-out",
};

const drawerStyle = {
  width: "560px",
  maxWidth: "92vw",
  height: "100%",
  background: "#ffffff",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 0 20px rgba(0,0,0,0.15)",
  animation: "kpiDrawerSlide 0.25s ease-out",
};

const headerStyle = {
  padding: "16px 20px",
  borderBottom: "1px solid #e5e7eb",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: "#fff",
  position: "sticky",
  top: 0,
  zIndex: 10,
};

const closeButtonStyle = {
  background: "transparent",
  border: "none",
  cursor: "pointer",
  fontSize: "16px",
  color: "#6b7280",
  padding: "4px 8px",
};

const contentStyle = {
  padding: "12px 16px",
  overflowY: "auto",
  flex: 1,
};
